/**
 * Form helpers for new hire questions (plain TS so react-refresh can treat
 * NewHireQuestionsFields.tsx as components-only).
 */

export const nhqFieldKey = (questionId: string) => `nhq_${questionId}`;

export const extractNewHireQuestionAnswers = (
  values: Record<string, any>,
  questions: NewHireQuestion[]
): NewHireQuestionAnswer[] => {
  return questions
    .map((q) => {
      const key = nhqFieldKey(q.id);
      const rawValue = values[key];
      const answer =
        rawValue !== undefined && rawValue !== null ? String(rawValue) : '';
      return { question_id: q.id, answer };
    })
    .filter((a) => a.answer !== '');
};
